import { render, staticRenderFns } from "./app-btn.vue?vue&type=template&id=21f9497a&scoped=true&"
import script from "./app-btn.vue?vue&type=script&lang=js&"
export * from "./app-btn.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "21f9497a",
  null
  ,true
)

export default component.exports